import urls from '../api_urls/myProfile'
import { _post } from '@/axios/request'
// 获取验证码
export function getCode (params) {
  return _post(urls.GET_CODE, params)
}
// 提交验证码
export function confirmCode (params) {
  return _post(urls.CONFIRM_CODE, params)
}



// WEBPACK FOOTER //
// ./src/axios/api/myProfile.js